import { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export interface Tab {
  to: string;
  label: string;
  end?: boolean;
}

/**
 * Section tabs (Account, organization, admin). On phones they stay on one
 * row and scroll sideways, edge to edge, with the active tab kept in view;
 * on wider screens they look like ordinary tabs.
 */
export function TabNav({ tabs, className = '' }: { tabs: Tab[]; className?: string }) {
  const ref = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  useEffect(() => {
    ref.current
      ?.querySelector('[aria-current="page"]')
      ?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }, [pathname]);

  return (
    <nav
      ref={ref}
      className={`-mx-4 overflow-x-auto px-4 [scrollbar-width:none] sm:mx-0 sm:px-0 [&::-webkit-scrollbar]:hidden ${className}`}
    >
      <div className="flex w-max min-w-full gap-1 border-b border-border">
        {tabs.map((t) => (
          <NavLink
            key={t.label}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `-mb-px whitespace-nowrap border-b-2 px-3 py-2.5 text-sm ${isActive ? 'border-primary font-medium text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
